module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section section-white"
  }, [_c('div', {
    staticClass: "section-header with-border"
  }, [_vm._v("\n    添加商品\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "section-body"
  }, [_c('el-form', {
    ref: "form",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.form,
      "label-width": "150px",
      "label-position": "left"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "核销类型"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.form.consume_type),
      callback: function($$v) {
        _vm.$set(_vm.form, "consume_type", $$v)
      },
      expression: "form.consume_type"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "every",
      "disabled": _vm.form.item_id !== '' && _vm.form.consume_type === 'all' ? true : false
    }
  }, [_vm._v("次卡类型 "), _c('span', {
    staticClass: "frm-tips"
  }, [_vm._v("(每个物料都需要核销)")])])], 1), _vm._v(" "), _c('div', [_c('el-radio', {
    attrs: {
      "label": "all",
      "disabled": _vm.form.item_id !== '' && _vm.form.consume_type === 'every' ? true : false
    }
  }, [_vm._v("团购券类型 "), _c('span', {
    staticClass: "frm-tips"
  }, [_vm._v("(所有物料作为一个整体，只核销一次)")])])], 1)])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "商品名称"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 30,
      "placeholder": ""
    },
    model: {
      value: (_vm.form.item_name),
      callback: function($$v) {
        _vm.$set(_vm.form, "item_name", $$v)
      },
      expression: "form.item_name"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "简洁的描述"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.form.brief),
      callback: function($$v) {
        _vm.$set(_vm.form, "brief", $$v)
      },
      expression: "form.brief"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "成本价"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "required": "",
      "min": "0",
      "placeholder": ""
    },
    model: {
      value: (_vm.form.cost_price),
      callback: function($$v) {
        _vm.$set(_vm.form, "cost_price", $$v)
      },
      expression: "form.cost_price"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_vm._v("\n         元\n        ")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "销售价"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "required": "",
      "min": "0",
      "placeholder": ""
    },
    model: {
      value: (_vm.form.price),
      callback: function($$v) {
        _vm.$set(_vm.form, "price", $$v)
      },
      expression: "form.price"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_vm._v("\n         元\n        ")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "商品状态"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.form.approve_status),
      callback: function($$v) {
        _vm.$set(_vm.form, "approve_status", $$v)
      },
      expression: "form.approve_status"
    }
  }, _vm._l((_vm.statusOption), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.title,
        "value": item.value
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "排序编号"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.form.sort),
      callback: function($$v) {
        _vm.$set(_vm.form, "sort", $$v)
      },
      expression: "form.sort"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_vm._v("数字越大越靠前")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "商品内容"
    }
  }, [_c('div', {
    staticClass: "content-bottom-padded"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small",
      "icon": "plus"
    },
    on: {
      "click": _vm.addLabel
    }
  }, [_vm._v("选择基础物料")])], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "line-height": "normal"
    },
    attrs: {
      "data": _vm.form.type_labels,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "物料名称",
      "prop": "labelName",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "单价(元)",
      "width": "90"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-col', {
          attrs: {
            "span": 12
          }
        }, [_vm._v("￥" + _vm._s(scope.row.labelPrice))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "数量"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-row', [_c('el-col', {
          attrs: {
            "span": 12
          }
        }, [_c('el-radio', {
          attrs: {
            "label": 2
          },
          model: {
            value: (scope.row.isNotLimitNum),
            callback: function($$v) {
              _vm.$set(scope.row, "isNotLimitNum", $$v)
            },
            expression: "scope.row.isNotLimitNum"
          }
        }, [_vm._v("限制数量")]), _vm._v(" "), _c('el-radio', {
          attrs: {
            "label": 1
          },
          model: {
            value: (scope.row.isNotLimitNum),
            callback: function($$v) {
              _vm.$set(scope.row, "isNotLimitNum", $$v)
            },
            expression: "scope.row.isNotLimitNum"
          }
        }, [_vm._v("不限数量")])], 1), _vm._v(" "), (scope.row.isNotLimitNum == 2) ? _c('el-col', {
          attrs: {
            "span": 12
          }
        }, [_c('el-input', {
          attrs: {
            "type": "number",
            "min": "1",
            "placeholder": "整数"
          },
          on: {
            "change": _vm.handleMarketPrice
          },
          model: {
            value: (scope.row.num),
            callback: function($$v) {
              _vm.$set(scope.row, "num", $$v)
            },
            expression: "scope.row.num"
          }
        })], 1) : _vm._e()], 1), _vm._v(" "), _c('el-row')]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "有效期(天)",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-col', {
          attrs: {
            "span": 24
          }
        }, [_c('el-input', {
          attrs: {
            "disabled": _vm.form.consume_type === 'all' ? true : false,
            "type": "number",
            "min": "1",
            "placeholder": "正整数"
          },
          model: {
            value: (scope.row.limitTime),
            callback: function($$v) {
              _vm.$set(scope.row, "limitTime", $$v)
            },
            expression: "scope.row.limitTime"
          }
        })], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small",
            "icon": "delete",
            "type": "danger"
          },
          nativeOn: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.deleteServiceLabelsAction(scope.$index, _vm.form.type_labels)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "原价"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "required": "",
      "min": "0",
      "placeholder": ""
    },
    model: {
      value: (_vm.form.market_price),
      callback: function($$v) {
        _vm.$set(_vm.form, "market_price", $$v)
      },
      expression: "form.market_price"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_vm._v("\n         元\n        ")])], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.consume_type === 'all'),
      expression: "form.consume_type==='all'"
    }],
    attrs: {
      "label": "有效期",
      "prop": "date_type"
    }
  }, [_c('el-radio-group', {
    on: {
      "change": _vm.changeDatetime
    },
    model: {
      value: (_vm.form.date_type),
      callback: function($$v) {
        _vm.$set(_vm.form, "date_type", $$v)
      },
      expression: "form.date_type"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('el-radio', {
    attrs: {
      "disabled": _vm.form.item_id !== '' && _vm.form.date_type === 'DATE_TYPE_FIX_TERM' ? true : false,
      "label": "DATE_TYPE_FIX_TIME_RANGE"
    }
  }, [_vm._v("固定日期  ")]), _vm._v(" "), _c('el-date-picker', {
    staticStyle: {
      "width": "215px"
    },
    attrs: {
      "type": "daterange",
      "format": "yyyy-MM-dd",
      "picker-options": _vm.form.item_id ? '' : _vm.pickerOptions,
      "disabled": _vm.form.item_id !== '' && _vm.form.date_type == 'DATE_TYPE_FIX_TERM' ? true : false
    },
    model: {
      value: (_vm.date_range),
      callback: function($$v) {
        _vm.date_range = $$v
      },
      expression: "date_range"
    }
  })], 1), _vm._v(" "), _c('div', [_c('el-radio', {
    attrs: {
      "disabled": _vm.form.item_id !== '' && _vm.form.date_type === 'DATE_TYPE_FIX_TIME_RANGE' ? true : false,
      "label": "DATE_TYPE_FIX_TERM"
    }
  }, [_vm._v("\n              领取后    \n              "), _c('el-input', {
    staticStyle: {
      "width": "60px"
    },
    attrs: {
      "disabled": _vm.form.item_id !== '' && _vm.form.date_type === 'DATE_TYPE_FIX_TIME_RANGE' ? true : false,
      "type": "number",
      "min": "1",
      "placeholder": ""
    },
    model: {
      value: (_vm.form.fixed_term),
      callback: function($$v) {
        _vm.$set(_vm.form, "fixed_term", $$v)
      },
      expression: "form.fixed_term"
    }
  }), _vm._v("\n              天内有效\n            ")], 1)], 1)])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "图片"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 18
    }
  }, [_c('div', {
    staticClass: "frm-tips"
  }, [_vm._v("最多可上传9个图片，文件格式为bmp、png、jpeg、jpg或gif，大小不超过2M（建议尺寸：375px * 200px）")]), _vm._v(" "), _c('div', {
    staticClass: "pics-box"
  }, [_c('ul', {
    staticClass: "goodspic-wrap"
  }, _vm._l((_vm.form.pics), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "goodspic",
      on: {
        "mouseenter": function($event) {
          return _vm.picsEnter(index)
        },
        "mouseleave": _vm.picsLeave
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.wximageurl + item
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "goodspic-mask",
      class: (_vm.picsCurrent == index) ? 'on' : '',
      on: {
        "click": function($event) {
          return _vm.removePicsImg(index)
        }
      }
    }, [_c('i', {
      staticClass: "iconfont icon-trash-alt1 icon1"
    })])])
  }), 0), _vm._v(" "), (_vm.form.pics.length < 9) ? _c('div', {
    staticClass: "upload-box",
    on: {
      "click": _vm.handlePicsChange
    }
  }, [_c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })]) : _vm._e()]), _vm._v(" "), _c('imgPicker', {
    attrs: {
      "dialog-visible": _vm.picsDialog,
      "sc-status": _vm.isGetPics,
      "isMost": true
    },
    on: {
      "chooseImg": _vm.pickPics,
      "closeImgDialog": _vm.closePicsDialog
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "详情"
    }
  }, [_c('vue-html5-editor', {
    ref: "editor",
    attrs: {
      "content": _vm.form.intro,
      "height": 360
    },
    on: {
      "change": _vm.updateContent
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "开启购买协议"
    }
  }, [_c('el-switch', {
    attrs: {
      "active-color": "#13ce66",
      "inactive-color": "#ff4949"
    },
    model: {
      value: (_vm.form.enable_agreement),
      callback: function($$v) {
        _vm.$set(_vm.form, "enable_agreement", $$v)
      },
      expression: "form.enable_agreement"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "购买协议"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 6
      },
      "placeholder": "请输入购买协议"
    },
    model: {
      value: (_vm.form.purchase_agreement),
      callback: function($$v) {
        _vm.$set(_vm.form, "purchase_agreement", $$v)
      },
      expression: "form.purchase_agreement"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": " "
    }
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        return _vm.handleCancel.apply(null, arguments)
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submitItemsAction
    }
  }, [_vm._v("保存")])], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "选择基础物料",
      "visible": _vm.serviceLabelsVisible,
      "before-close": _vm.handleCancelLabelsDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.serviceLabelsVisible = $event
      }
    }
  }, [
    [(_vm.total_count > _vm.params.pageSize) ? _c('div', {
      staticClass: "f_r"
    }, [_c('el-pagination', {
      attrs: {
        "layout": "prev, pager, next",
        "total": _vm.total_count,
        "page-size": _vm.params.pageSize
      },
      on: {
        "current-change": _vm.handleCurrentChange
      }
    })], 1) : _vm._e(), _vm._v(" "), _c('el-table', {
      ref: "multipleTable",
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "data": _vm.serviceLabelsList,
        "row-key": _vm.handleRowKey
      },
      on: {
        "select": _vm.handleSelectionChange
      }
    }, [_c('el-table-column', {
      attrs: {
        "type": "selection",
        "reserve-selection": true,
        "width": "55"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "labelName",
        "label": "物料名称"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "serviceType",
        "label": "系统类型"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [(scope.row.serviceType === 'point') ? _c('span', [_vm._v("积分")]) : _vm._e(), _vm._v(" "), (scope.row.serviceType === 'deposit') ? _c('span', [_vm._v("储值")]) : _vm._e(), _vm._v(" "), (scope.row.serviceType === 'timescard') ? _c('span', [_vm._v("次卡")]) : _vm._e()]
        }
      }])
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "label": "物料价格"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('span', [_vm._v("￥" + _vm._s(scope.row.labelPrice / 100))])]
        }
      }])
    })], 1)]
  ], 2)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-77ab65b7", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-77ab65b7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/mall/goods/service/items/add.vue
// module id = 2840
// module chunks = 0